import React from 'react';

import PropTypes from 'prop-types';

import './ContactPersonItem.sass';

export const ContactPersonItem = ({
  title = '',
  name,
  phoneNumber,
  phoneNumbers,
  phoneNumberDisplay = [],
  email = '',
  emails = [],
  additionalContainerStyle = {},
}) => (
  <div className="contact-person-item" style={additionalContainerStyle}>
    <div className="contact-person-item__title">{title || <span>&nbsp;</span>}</div>
    <div className="contact-person-item__name">{name}</div>
    {phoneNumber && (
      <div className="contact-person-item__phone">
        <a href={`tel:${phoneNumber}`}>
          <span className="contact-person-item-phone__icon">T</span>
          {phoneNumberDisplay}
        </a>
      </div>
    )}
    {phoneNumbers ? (
      <div className="contact-person-item__multi-contact-item">
        {phoneNumbers.map((phoneNumberLoop, i) => (
          <div key={phoneNumberLoop}>
            <div className="contact-person-item__phone">
              <a href={`tel:${phoneNumberLoop}`}>
                <span className="contact-person-item-phone__icon">T</span>
                {phoneNumberDisplay[i]}
              </a>
            </div>
            <div className="contact-person-item__email" key={emails[i]}>
              <a href={`mailto:${emails[i]}`} className="email">
                {emails[i]}
              </a>
            </div>
          </div>
        ))}
      </div>
    ) : null}

    {email && (
      <div className="contact-person-item__email">
        <a href={`mailto:${email}`} className="email">
          {email}
        </a>
      </div>
    )}
  </div>
);

ContactPersonItem.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  phoneNumbers: PropTypes.array,
  phoneNumberDisplay: PropTypes.array,
  email: PropTypes.string,
  emails: PropTypes.array,
  additionalContainerStyle: PropTypes.object,
};

ContactPersonItem.defaultProps = {
  title: '',
  name: '',
  phoneNumber: '',
  phoneNumbers: [],
  phoneNumberDisplay: [],
  email: '',
  emails: [],
  additionalContainerStyle: {},
};
